import '../styles/Footer.css';

const services = [
  { label: 'DevOps', page: 'DevOps' },
  { label: 'Power BI', page: 'PowerBI' },
  { label: 'JAVA', page: 'Java' },
  { label: 'Big Data', page: 'BigData' },
  { label: 'Life Science Services', page: 'LifeScienceServices' },
  { label: 'Healthcare Services', page: 'HealthcareServices' }
];

const quickLinks = [
  { label: 'About Us', page: 'AboutUs' },
  { label: 'Our Services', page: 'Home' },
  { label: 'Careers', page: 'Careers' },
  { label: 'Contact Us', page: 'Contact' }
];

const socials = [
  {
    name: 'Facebook',
    url: 'https://facebook.com',
    path: 'M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.5-3.91 3.77-3.91 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.45 2.91h-2.33V22c4.78-.76 8.44-4.92 8.44-9.94z'
  },
  {
    name: 'Twitter',
    url: 'https://twitter.com',
    path: 'M22 5.92a8.2 8.2 0 0 1-2.36.65 4.11 4.11 0 0 0 1.8-2.27 8.22 8.22 0 0 1-2.6 1 4.1 4.1 0 0 0-7 3.74A11.64 11.64 0 0 1 3.4 4.75a4.1 4.1 0 0 0 1.27 5.47 4.07 4.07 0 0 1-1.86-.51v.05a4.1 4.1 0 0 0 3.29 4.02 4.1 4.1 0 0 1-1.85.07 4.1 4.1 0 0 0 3.83 2.85A8.23 8.23 0 0 1 2 18.41a11.6 11.6 0 0 0 6.29 1.84c7.55 0 11.68-6.25 11.68-11.67v-.53A8.3 8.3 0 0 0 22 5.92z'
  },
  {
    name: 'WhatsApp',
    url: 'https://wa.me/18039939004',
    path: 'M12.04 2c-5.5 0-9.96 4.46-9.96 9.96 0 1.76.46 3.48 1.34 5L2 22l5.16-1.35a9.93 9.93 0 0 0 4.88 1.27h.01c5.49 0 9.95-4.46 9.95-9.96 0-2.66-1.03-5.16-2.91-7.04A9.9 9.9 0 0 0 12.04 2zm5.83 14.24c-.25.7-1.44 1.33-2 1.42-.51.08-1.16.11-1.87-.12-.43-.13-.99-.32-1.7-.63-2.99-1.29-4.94-4.3-5.09-4.5-.15-.2-1.22-1.62-1.22-3.09s.77-2.19 1.04-2.49c.27-.3.59-.37.79-.37h.57c.18 0 .43-.07.67.51.25.6.84 2.07.91 2.22.07.15.12.32.02.52-.1.2-.15.32-.3.5-.15.17-.31.39-.45.52-.15.15-.3.31-.13.61.17.3.76 1.25 1.63 2.03 1.12 1 2.06 1.31 2.36 1.46.3.15.47.12.65-.07.17-.2.75-.87.95-1.17.2-.3.4-.25.67-.15.27.1 1.74.82 2.04.97.3.15.5.22.57.35.07.12.07.72-.18 1.42z'
  },
  {
    name: 'Instagram',
    url: 'https://instagram.com',
    path: 'M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.26.07 1.64.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.26.06-1.64.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9a3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zm0 5.68a4.16 4.16 0 1 0 0 8.32 4.16 4.16 0 0 0 0-8.32zm0 6.86a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zm5.3-7.02a.97.97 0 1 1-1.94 0 .97.97 0 0 1 1.94 0z'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/company/digicloud-llc/',
    path: 'M6.94 5a1.94 1.94 0 1 1-3.88 0 1.94 1.94 0 0 1 3.88 0zM3.2 8.44h3.5V21H3.2V8.44zM9.5 8.44H13v1.72h.05c.49-.88 1.68-1.8 3.45-1.8 3.69 0 4.37 2.3 4.37 5.28V21h-3.5v-5.65c0-1.35-.03-3.08-1.9-3.08-1.9 0-2.19 1.46-2.19 2.98V21H9.5V8.44z'
  }
];

const footerBackground = {
  backgroundImage:
    `linear-gradient(rgba(19, 37, 58, 0.94), rgba(19, 37, 58, 0.94)), url('${process.env.PUBLIC_URL}/images/hero.png')`
};

function Footer({ setCurrentPage }) {
  const goTo = (page) => (e) => {
    e.preventDefault();
    if (setCurrentPage) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer" style={footerBackground}>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-about">
            <h3>Our Company</h3>
            <p>
              Powering businesses across the globe with our deep IT consulting and
              services expertise in modern technology, we bring the industry’s best
              practices to deliver quality business outcomes.
            </p>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul className="footer-list">
              {services.map((item) => (
                <li key={item.label}>
                  <a href="/" onClick={goTo(item.page)}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Detail</h3>
            <p className="footer-lead">Feel free to contact &amp; reach us !</p>
            <p><span className="footer-key">Address :</span> 301 McCullough Dr, Charlotte, NC-28262</p>
            <p>
              <span className="footer-key">Email :</span>{' '}
              <a href="mailto:hr@digicloudllc.com">hr@digicloudllc.com</a>
            </p>
            <p>
              <span className="footer-key">Phone :</span>{' '}
              <a href="tel:+18039939004">+1 803 993 9004</a>
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-list">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <a href="/" onClick={goTo(item.page)}>{item.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-social">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.name}
              className="footer-social-icon"
            >
              <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                <path fill="currentColor" d={s.path} />
              </svg>
            </a>
          ))}
        </div>

        <div className="footer-bottom">
          <p>Copyright &copy; 2026 DigiCloud LLC. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
